var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWalletOutline(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Size(PX)=24, Style=Outline",
    clipPath: "url(#clip0_4022_60321)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.1835 2.03996C18.0571 2.0432 17.9241 2.05942 17.7945 2.09184L4.30695 5.64528C3.21758 5.93059 2.43945 6.92918 2.43945 8.05746V19.47C2.43945 20.8349 3.56449 21.96 4.92945 21.96H19.8695C21.2344 21.96 22.3595 20.8349 22.3595 19.47V8.67996C22.3595 7.315 21.2344 6.18996 19.8695 6.18996H8.7682L18.2095 3.69996V5.35996H19.8695V3.69996C19.8695 2.76621 19.0751 2.02699 18.1835 2.03996ZM4.92945 7.84996H19.8695C20.3396 7.84996 20.6995 8.20985 20.6995 8.67996V19.47C20.6995 19.9401 20.3396 20.3 19.8695 20.3H4.92945C4.45934 20.3 4.09945 19.9401 4.09945 19.47V8.67996C4.09945 8.20985 4.45934 7.84996 4.92945 7.84996ZM17.7945 12.83C17.1071 12.83 16.5495 13.3876 16.5495 14.075C16.5495 14.7623 17.1071 15.32 17.7945 15.32C18.4818 15.32 19.0395 14.7623 19.0395 14.075C19.0395 13.3876 18.4818 12.83 17.7945 12.83Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4022_60321"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.400391)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletOutline);
export default __webpack_public_path__ + "static/media/wallet-outline.265ed62252638da6536bc9d123bc0803.svg";
export { ForwardRef as ReactComponent };